import { botaoCirculo, botaoCirculoHover, boxShadow } from 'routes/styl';
import styled from 'styled-components';

export const Container = styled.div.attrs({ className: 'modal-center' })<any>`
    width: 72rem;
    max-width: 100%;
    ${boxShadow};
    padding: 2rem;
`;

export const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
    h1 {
        color: var(--btn-admin-icone);
    }
    span {
        display: block;
        margin-top: 0.4rem;
        font-size: 1.3rem;
        color: var(--text-cor);
    }
    button {
        padding: 0 1rem;
        ${botaoCirculo}
        .font-ic {
            position: relative;
            z-index: 2;
        }
        &:hover::after {
            ${botaoCirculoHover}
        }
    }
`;

export const Mensagem = styled.p`
    padding: 3rem 0;
    text-align: center;
    font-size: 1.4rem;
    color: var(--text-cor);
`;

export const Lista = styled.div`
    max-height: 60vh;
    overflow-y: auto;

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 1.3rem;
        color: var(--text-cor);
    }
    th,
    td {
        padding: 0.8rem 1rem;
        text-align: left;
        border-bottom: 1px solid var(--placeholder, #ccc);
    }
    th {
        position: sticky;
        top: 0;
        background: var(--bg-white, #fff);
        font-size: 1.2rem;
    }
    th:last-child,
    td:last-child {
        text-align: right;
        white-space: nowrap;
    }
    td small {
        display: block;
        font-size: 1.1rem;
        opacity: 0.75;
    }
`;

export const Totais = styled.footer`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 2.5rem;
    margin-top: 1.5rem;

    div {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        font-size: 1.2rem;
        color: var(--text-cor);
    }
    strong {
        font-size: 1.6rem;
    }
`;
